import KeySettingTypes from 'store/actionTypes/keySetting'
import UserTypes from 'store/actionTypes/user'

const initialData = {
  current: {},
  activity: {
    list: [],
    pagination: {}
  }
}

const keySetting = (state = initialData, action = {}) => {
  const { payload } = action

  switch (action.type) {
    case KeySettingTypes.GET_KEY_SETTINGS_SUCCESS:
      return {
        ...state,
        current: payload?.keysSettings
      }
    case KeySettingTypes.GET_KEY_SETTINGS_COMMENTS_SUCCESS:
      // eslint-disable-next-line no-case-declarations
      const isFirstPage = action?.meta?.params?.page <= 1
      return {
        ...state,
        activity: {
          list: isFirstPage
            ? payload?.items || []
            : [...state.activity.list, ...(payload?.items || [])],
          pagination: payload?.meta || {}
        }
      }

    case UserTypes.LOGOUT_SUCCESS:
      return initialData
    default:
      return state
  }
}

export default keySetting
